import React, {
  ReactNode,
  ReactElement,
  MouseEvent,
  InputHTMLAttributes,
} from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

export interface Props
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'title'> {
  /** 左侧内容 */
  title?: ReactNode;
  /** 左侧辅助说明内容 */
  subtitle?: ReactNode;
  /** input 原生 title 属性 */
  inputTitle?: string;
  /** 右侧内容 */
  extra?: ReactNode;
  /** 样式名称 */
  className?: string;
  /** 是否显示左侧内容后的冒号 */
  colon?: boolean;
  borderBottom?: boolean;
  /** 点击 item 后的回调函数 */
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
}

function InputItem(props: Props): ReactElement {
  const {
    title,
    inputTitle,
    children,
    className,
    onClick,
    colon = true,
    extra,
    subtitle,
    borderBottom,
    ...rest
  } = props;

  const itemCls = classNames(styles.listItemClass, className, {
    [styles.listItemLineClass]: !children,
    [styles.listItemBorderBottom]: borderBottom,
  });

  const titleCls = classNames(styles.listItemTitleClass, {
    [styles.listItemTitleWithColon]: colon,
  });

  const renderTitle = (): ReactNode => {
    if (!title) {
      return null;
    }

    return (
      <div className={styles.listItemTitleWrapper}>
        <div className={titleCls}>{title}</div>
        {subtitle && <div className={styles.listItemSubtitle}>{subtitle}</div>}
      </div>
    );
  };

  const handleClick = (e: MouseEvent<HTMLDivElement>): void => {
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <div className={itemCls} onClick={handleClick}>
      {renderTitle()}
      <div className={styles.listItemExtraClass}>
        <input className={styles.input} {...rest} title={inputTitle} />
        <span style={{ flex: '0 0 auto' }}>{extra}</span>
      </div>
    </div>
  );
}

export default InputItem;
